@if (downloadEnabled) {
    <bizz-icon (click)="downloadFile()" class="icon-button size-5 sm:size-4" iconName="download" transform="grow-2"></bizz-icon>
}

